import styled from '@emotion/styled';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import {
    SurveyDummyQuestion,
    SurveyQuestionType,
} from 'src/modules/programs/surveys/models/surveys';
import { SimpleSurveyStep } from 'src/modules/programs/surveys/stepComponents/SimpleSurveyStep';
import { color, font } from 'src/shared/styles/variables';

import { CBTProgramWeekFiveSurvey } from '../models/weekFive';

const PointsList = styled.ol({
    paddingLeft: '1.3rem',
    margin: '0.5rem 0 0',
});

const PointsListElement = styled.li(
    {
        whiteSpace: 'pre-wrap',
        color: color.tundora,
        marginBottom: '0.5rem',

        '&:last-child': {
            marginBottom: 0,
        },
    },
    font.book(font.size.medium),
);

interface Props extends StepButtonsProps, WithTranslation {
    programId: ProgramEnum;
}

export const IdentifyAnAlternativeThoughtStep = withTranslation('cbt')((props: Props) => {
    const dummyQuestionPoints: string[] = props.t(
        'week-5.identify-an-alternative-thought.dummyQuestion.points',
        {
            returnObjects: true,
        },
    );

    const dummyQuestion: SurveyDummyQuestion = {
        id: 0,
        type: SurveyQuestionType.Dummy,
        question: props.t('week-5.identify-an-alternative-thought.dummyQuestion.header'),
        index: 2,
        content: (
            <PointsList>
                {dummyQuestionPoints.map(point => (
                    <PointsListElement key={point}>{point}</PointsListElement>
                ))}
            </PointsList>
        ),
    };

    return (
        <SimpleSurveyStep
            {...props}
            programId={props.programId}
            surveyId={CBTProgramWeekFiveSurvey.IdentifyAnAlternativeThought}
            heading={
                <>
                    <S.StepHeading>
                        {props.t('week-5.identify-an-alternative-thought.title')}
                    </S.StepHeading>
                    <S.StepDescription small>
                        {props.t('week-5.identify-an-alternative-thought.description')}
                    </S.StepDescription>
                </>
            }
            dummyQuestion={dummyQuestion}
            showQuestionsIndexes
        />
    );
});
